import { render, staticRenderFns } from "./TeamRank.vue?vue&type=template&id=516d4a37&scoped=true&"
import script from "./TeamRank.vue?vue&type=script&lang=js&"
export * from "./TeamRank.vue?vue&type=script&lang=js&"
import style0 from "./TeamRank.vue?vue&type=style&index=0&id=516d4a37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516d4a37",
  null
  
)

export default component.exports